import { useState } from "react";
import { useI18n } from "../i18n";
import { ModuleGrid } from "../components/ModuleGrid";
import { applyModules } from "../data";
import type { Workspace } from "../types";

export function ModulesPage({ ws, onSaved }: { ws: Workspace; onSaved: () => void }) {
  const { t } = useI18n();
  const [target, setTarget] = useState(() => new Set(ws.enabled));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const canManage = ws.permissions.has("modules.manage");
  const dirty = target.size !== ws.enabled.size || [...target].some((k) => !ws.enabled.has(k));

  async function save() {
    setBusy(true);
    setError(null);
    setSaved(false);
    try {
      await applyModules(ws.membership.company_id, ws.enabled, target, ws.catalog);
      setSaved(true);
      onSaved();
    } catch (err) {
      setError(err instanceof Error ? err.message : t("errorGeneric"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="page">
      <p className="muted">{t("modulesPageHelp")}</p>
      {!canManage && <p className="alert info">{t("noPermission")}</p>}
      <ModuleGrid catalog={ws.catalog} enabled={target} onChange={(n) => { setTarget(n); setSaved(false); }} disabled={!canManage || busy} />
      {error && <p className="alert danger" role="alert">{error}</p>}
      <div className="actions sticky-actions">
        {saved && <span className="badge success">{t("saved")}</span>}
        <button type="button" className="btn primary" disabled={!canManage || !dirty || busy} onClick={save}>
          {t("saveChanges")}
        </button>
      </div>
    </div>
  );
}
